import styles from "./SubscriptionAlert.module.css";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { useMediaQuery, useTheme } from "@mui/material";

const SubscriptionAlert = ({ paymentStatus, theme, expirationDate, role }: any) => {
  const themeMUI = useTheme();
  const history = useHistory();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  if (isMobile) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: "10px" }}>
      <div className="d-flex flex-column align-items-center m-auto p-2 alert alert-danger" style={{ zIndex: 1000, width: "40%", height: "30px", position: 'absolute', display: 'flex', alignItems: "center", justifyContent: 'center' }}>
        <div style={{ display: 'flex', alignItems: "center", justifyContent: 'center' }}>
          {paymentStatus === false ? (
            <p className="text-center" style={{ marginTop: "2.5%", margin: 0, fontSize: "12px" }}>
              Subscription expired. All users deactivated. Please renew to continue.
            </p>
          ) : (
            <p className="text-center" style={{ marginTop: "2.5%", margin: 0, fontSize: "12px" }}>
              Subscription expires on {expirationDate}. Renew to avoid deactivation.
            </p>
          )}<br />
          {role === "Admin" &&
            <div>
              <button
                onClick={() => {
                  history.push("/paymentDetails");
                }}
                className={styles.button}
                style={{ fontSize: "12px", fontWeight: "400", padding: 0, height: "20px", marginLeft: "5px" }}
              >
                Renew Now
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    expirationDate: state.organization.expirationDate,
  };
};

export default connect(mapStateToProps)(SubscriptionAlert);
